export default __webpack_public_path__ + "static/media/filter.1ed63101.png";